export * from './post-rechnung.component';
export * from './post-rechnung.component.module';